module.exports = __webpack_public_path__ + "static/media/call.1a0b9e0f.svg";